module.exports = __webpack_public_path__ + "img/mbBanner12.b75ad15e.png";